module.exports = __webpack_public_path__ + "way2go/static/config/icon_hand.svg";